module.exports = __webpack_public_path__ + "static/media/0_2.e4a3a823.png";